module.exports = __webpack_public_path__ + "static/media/concertphoto.dacca721.jpg";